import { quickViewPath } from '../../../routes/paths';
import { SURVEY_TYPE } from '../../../config/EntityTypeList';

export default (id, params = {}) => {
  const { entityType = SURVEY_TYPE, openInModal = true, ...restState } = params;

  return {
    pathname: `${quickViewPath}/${entityType}/${id}`,
    state: { modal: Boolean(openInModal), ...restState },
  };
};
